import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faMinus } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';

const AccordionSection = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const { t } = useTranslation(); 

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const accordionItems = [
    {
      title: t('WorkProcess.accordion.title1'),
      content: t('WorkProcess.accordion.content1'),
    },
    {
      title: t('WorkProcess.accordion.title2'),
      content: t('WorkProcess.accordion.content2'),
    },
    {
      title: t('WorkProcess.accordion.title3'),
      content: t('WorkProcess.accordion.content3'),
    },
    {
      title: t('WorkProcess.accordion.title4'),
      content: t('WorkProcess.accordion.content4'),
    },
    {
      title: t('WorkProcess.accordion.title5'),
      content: t('WorkProcess.accordion.content5'),
    },
    {
      title: t('WorkProcess.accordion.title6'),
      content: t('WorkProcess.accordion.content6'),
    }
  ];

  return (
    <section className="bg-slate-100 dark:bg-gray-800 py-12">
      <div className="px-6 lg:px-20 mb-8">
        <h3 className="text-4xl font-bold text-blue-600 mb-6">{t('WorkProcess.title')}</h3>
        <p className="text-gray-600 dark:text-gray-400 max-w-2xl">
          {t('WorkProcess.description')}
        </p>
      </div>

      <div className="container mx-auto flex flex-col lg:flex-row items-center px-6 lg:px-20">
        <div className="w-full">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
            {accordionItems.map((item, index) => (
              <div key={index} className="relative mb-3">
                <h6 className="mb-0">
                  <button
                    className="relative flex items-center w-full p-4 font-semibold text-left transition-all ease-in border-b border-gray-300 dark:border-gray-700 cursor-pointer text-gray-800 dark:text-gray-200 group"
                    onClick={() => toggleAccordion(index)}
                  >
                    <span className="text-blue-600">{item.title}</span>
                    <FontAwesomeIcon
                      icon={openIndex === index ? faMinus : faPlus}
                      className="absolute right-4 text-blue-600 text-sm"
                    />
                  </button>
                </h6>
                <div
                  className={`overflow-hidden transition-all duration-[1000ms] ease-in-out ${
                    openIndex === index ? 'max-h-[500px]' : 'max-h-0'
                  }`}
                >
                  <div className="p-4 text-sm text-gray-700 dark:text-gray-300">
                    {item.content}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AccordionSection;
